import React, { useState } from 'react';
import { CalculatedFieldSnapshot } from '../../Survey/Util/calculatedFields';
import './SurveyRuntimeInspector.css';

export interface SurveyRuntimeInspectorProps {
    onOpenChange: (isOpen: boolean) => void;
    calculatedFieldSnapshots: CalculatedFieldSnapshot[] | null;
}

export default function SurveyRuntimeInspector({ onOpenChange, calculatedFieldSnapshots }: SurveyRuntimeInspectorProps) {
    const [isOpen, setIsOpen] = useState(false);

    if (calculatedFieldSnapshots === null) {
        return null;
    }

    function open() {
        setIsOpen(true);
        onOpenChange(true);
    }

    function close() {
        setIsOpen(false);
        onOpenChange(false);
    }

    return (
        <div className="survey-runtime-inspector">
            {!isOpen && (
                <button className="survey-runtime-inspector-tab" onClick={open}>
                    Calculated Field Results
                </button>
            )}
            {isOpen && (
                <div className="survey-runtime-inspector-panel">
                    <div className="survey-runtime-inspector-panel-header">
                        <span className="survey-runtime-inspector-title">Calculated Field Results</span>
                        <button className="survey-runtime-inspector-close" onClick={close}>
                            <i className="fa fa-close"></i>
                        </button>
                    </div>
                    <div className="survey-runtime-inspector-body">
                        {calculatedFieldSnapshots.length === 0 && (
                            <div className="survey-runtime-inspector-empty">No calculated fields</div>
                        )}
                        {calculatedFieldSnapshots.map(snapshot => (
                            <div key={snapshot.identifier} className="survey-runtime-inspector-field">
                                <div className="survey-runtime-inspector-field-name">{snapshot.identifier}</div>
                                {snapshot.error !== null
                                    ? <div className="survey-runtime-inspector-field-error">{snapshot.error}</div>
                                    : <div className="survey-runtime-inspector-field-value">{snapshot.value?.join(', ')}</div>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
